import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Video = ({
    autoPlay                = null,
    containerClassName      = null,
    className               = null,
    controls                = null,
    disablePictureInPicture = null,
    loop                    = null,
    muted                   = null,
    playsInline             = null,
    src                     = null,
}) => {
    return (
        <div className={containerClassName ? containerClassName : 'absolute top-0 right-0 bottom-0 left-0'}>
            <video
                autoPlay={autoPlay}
                className={className ? className : 'absolute height-100 width-100'}
                controls={controls}
                disablePictureInPicture={disablePictureInPicture}
                loop={loop}
                muted={muted}
                playsInline={playsInline}
                src={src} />
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    autoPlay               : PropTypes.bool,
    className              : PropTypes.string,
    containerClassName     : PropTypes.string,
    controls               : PropTypes.bool,
    disablePictureInPicture: PropTypes.bool,
    loop                   : PropTypes.bool,
    muted                  : PropTypes.bool,
    playsInline            : PropTypes.bool,
    src                    : PropTypes.string.isRequired
};

Video.propTypes = propTypes;

export { Video };

export default Video;
